export const ROUTES = {
  home: "/",
  login: "login",
  resetPassword: "password-reset",
  forgotPassword: "/forgot-password",
  notFound: "/not-found",
  internalError: "/internal-error",
  organizations: "/organizations",
  organizationInfo: "/organizations/:id/info",
  organizationSeats: "/organizations/:id/seats",
  organizationInvitations: "/organizations/:id/invitations",
} as const;
